// extracted by mini-css-extract-plugin
export default {"group":"styles_group__p3m52","xs":"styles_xs__6gtBp","sm":"styles_sm__kUZjf","md":"styles_md__fD+69","lg":"styles_lg__QSD-b","xl":"styles_xl__dlsmz"};